import { AlertTakeoverCampaign } from 'modules/campaigns/lib/takeovers/AlertTakeover/types';
import { CampaignTypeFilter, MessageMedium } from 'modules/domains/campaign';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface CampaignAlertsContextState {
  alertDetails: string[];
  campaignData: AlertTakeoverCampaign;
  hasProjectAlerts: boolean;
  isAlertTakeoverOpen: boolean;
  isLoadingAlerts: boolean;
  onTakeoverOpen: (isOpen: boolean) => void;
  refetchCampaignAlerts: () => void;
  hasRecentTriggeredAlerts?: boolean;
}

export const DEFAULT_CAMPAIGN_ALERTS_CONTEXT_STATE: CampaignAlertsContextState = {
  alertDetails: [],
  campaignData: {
    campaignId: 0,
    name: '',
    messageMedium: MessageMedium.Email,
    campaignType: CampaignTypeFilter.Blast,
  },
  hasProjectAlerts: false,
  isAlertTakeoverOpen: false,
  isLoadingAlerts: false,
  onTakeoverOpen: noop,
  refetchCampaignAlerts: noop,
  hasRecentTriggeredAlerts: false,
};

export const CampaignAlertsContext = createContext<CampaignAlertsContextState>(
  DEFAULT_CAMPAIGN_ALERTS_CONTEXT_STATE,
);
export const useCampaignAlertsContext = () => useContext(CampaignAlertsContext);
